////////////////////////////////////////
// # GOLDEN RULE!!!! HONOR ABOVE ALL!!!!
////////////////////////////////////////
// NO NEW FILES!!!!!!!!!
////////////////////////////////////////

/*
░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
*/
// ##                                                                                                               REQUIREMENTS 'R'
/*
░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
R: Taylor Legal Engineering Main Entry Point
- React 19 application bootstrap with routing
- Single-page app with smooth navigation
*/

// ═══════════════════════════════════════════════════════════════════════════════════════════════════════════════
// DVT_EIS_TP: THIRD-PARTY IMPORTS
// ═══════════════════════════════════════════════════════════════════════════════════════════════════════════════

import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';

// ═══════════════════════════════════════════════════════════════════════════════════════════════════════════════
// DVT_EIS_FP: FIRST-PARTY IMPORTS
// ═══════════════════════════════════════════════════════════════════════════════════════════════════════════════

import { TLE_Home_SRC_Homepage_Lobby_Pod } from '../homepage/lobby/pod/TaylorLegalEngineering_Home_SRC_Homepage_Lobby_Pod';


/*
████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████
*/
// ##                                                                                                               OUTPUTS 'O'
/*
████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████
*/

// ═══════════════════════════════════════════════════════════════════════════════════════════════════════════════
// O_1: REACT BOOTSTRAP WITH ROUTING
// ═══════════════════════════════════════════════════════════════════════════════════════════════════════════════

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);
root.render(
  <>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<TLE_Home_SRC_Homepage_Lobby_Pod />} />
      </Routes>
    </BrowserRouter>
    <Analytics />
  </>
);
